export default "__VITE_ASSET__BtnJ7qRL__"